<p-dialog
  #wizardModal
  [(visible)]="visible"
  (onHide)="visibleChange.emit(false)"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [dismissableMask]="false"
  [closable]="true"
  [style]="{ width: '760px', height: '90vh' }"
  [breakpoints]="{ '1024px': '85vw', '640px': '96vw' }"
  styleClass="loca-onboard-dialog"
  contentStyleClass="p-0"
>
  <ng-template pTemplate="header">
    <h1 class="fs-3 w-100 text-center">Asistente de Bienvenida</h1>
  </ng-template>

  <div class="h-100 d-flex flex-column align-items-center p-4 overflow-y-auto">
    <!-- Ilustración -->
    <img
      *ngIf="currentStep.img"
      [src]="currentStep.img"
      alt=""
      class="w-50 mb-4 rounded-lg"
    />

    <!-- Títulos y copy -->
    <h2 class="loca-onboard-h2">{{ currentStep.title }}</h2>
    <p class="loca-onboard-sub">{{ currentStep.subtitle }}</p>

    <!-- Contenido por paso -->
    <div class="loca-onboard-content">
      <!-- Paso 1: NIF/CIF -->
      <ng-container *ngIf="step === 1">
        <div class="loca-onboard-content text-center">
          <div class="nif-row">
            <label for="nif" class="loca-field-label">NIF/CIF de Cliente</label>

            <p-iconField class="w-full">
              <p-inputIcon styleClass="pi pi-id-card"></p-inputIcon>
              <input
                pInputText
                id="nif"
                class="w-full"
                autocomplete="off"
                placeholder="Ej.: 12345678Z"
                [(ngModel)]="nif"
              />
            </p-iconField>

            <p-button
              label="Comprobar autorización"
              icon="pi pi-shield-check"
              [disabled]="!nif || isSubmitting"
              [loading]="isSubmitting"
              [style]="{ background: 'blue', border: 'none' }"
              (onClick)="submitNif()"
            ></p-button>
          </div>

          <small class="loca-help">
            Formato: 8 dígitos + letra. Sin espacios ni guiones.
          </small>

          <p-tag
            *ngIf="requestDone"
            [severity]="resultSeverity"
            [icon]="resultIcon"
            [value]="resultText"
            class="w-full justify-center py-3 mt-3 text-base"
          />
        </div>
      </ng-container>
    </div>
  </div>

  <ng-template #footer>
    <div class="d-flex justify-content-center align-items-center w-100">
      <!-- Left slot (oculto visualmente en step 0, pero ocupa espacio) -->
      <p-button
        icon="pi pi-arrow-left"
        [rounded]="true"
        [text]="false"
        severity="success"
        class="loca-arrow loca-arrow-left"
        [style]="{ background: '#bfbfbf', border: 'none', width: '3rem', height: '3rem', padding: 0 }"
        [style.visibility]="step > 0 ? 'visible' : 'hidden'"
        [attr.tabindex]="step > 0 ? null : -1"
        [attr.aria-hidden]="step > 0 ? null : true"
        (onClick)="prev()"
      />
  
      <!-- Dots (siempre centrados) -->
      <ul class="loca-dots" aria-label="Progreso">
        <li
          *ngFor="let _ of steps; let i = index"
          [class.active]="i === step"
          [attr.aria-current]="i === step ? 'step' : null"
        ></li>
      </ul>
  
      <!-- Right slot -->
      <p-button
        [icon]="step === steps.length - 1 ? 'pi pi-check' : 'pi pi-arrow-right'"
        [rounded]="true"
        [text]="false"
        severity="primary"
        class="loca-arrow loca-arrow-right"
        [style]="{ background: '#10b981', border: 'none', width: '3rem', height: '3rem', padding: 0 }"
        (onClick)="step === steps.length - 1 ? skip() : next()"
      />
    </div>
  </ng-template>

</p-dialog>
